var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
export var ArrowRight = function (props) { return (React.createElement("svg", __assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "black", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.8232 19.8232C11.6279 19.6279 11.6279 19.3114 11.8232 19.1161L18.1893 12.75L3.49996 12.75C3.22382 12.75 2.99996 12.5261 2.99996 12.25L2.99996 11.75C2.99996 11.4738 3.22382 11.25 3.49996 11.25L18.1893 11.25L11.8232 4.88387C11.6279 4.68861 11.6279 4.37203 11.8232 4.17676L12.1767 3.82321C12.372 3.62795 12.6886 3.62795 12.8838 3.82321L20.7071 11.6464C20.9023 11.8417 20.9023 12.1583 20.7071 12.3535L12.8838 20.1768C12.6886 20.372 12.372 20.372 12.1767 20.1768L11.8232 19.8232Z", fill: "currentColor" }))); };
export default ArrowRight;
//# sourceMappingURL=ArrowRight.js.map